import axios from 'axios'
import {
	SIGNSTORE_APP_BASE,
	CAR_POINT_INDEX_LEGACY,
	CAR_RULE_POINT_INDEX
} from './config.js'
function getStoredToken() {
	try {
		const t = window.localStorage.getItem('token')
		const s = t != null ? String(t).trim() : ''
		return s && s !== 'null' && s !== 'undefined' ? s : ''
	} catch (e) {
		return ''
	}
}

function isApiOk(res) {
	return res && Number(res.status) === 200
}

function isUnauthorizedResponse(res) {
	if (!res || typeof res !== 'object') return false
	if (Number(res.status) === 401) return true
	const msg = res.msg != null ? String(res.msg) : ''
	return /非法访问|未授权|未登录/i.test(msg)
}

/** 带 Bearer 的 signstore / wxapp 请求，返回 ApiResult  body */
export async function signstoreRequest(config) {
	const token = getStoredToken()
	const res = await axios({
		method: config.method || 'get',
		url: SIGNSTORE_APP_BASE + config.url,
		params: config.params,
		data: config.data,
		timeout: config.timeout || 15000,
		headers: {
			'Content-Type': 'application/json',
			...(token ? { Authorization: 'Bearer ' + token } : {}),
			...(config.headers || {})
		}
	})
	return res.data
}

export function getCarActivityUserId() {
	return window.__carActivityUserId != null ? window.__carActivityUserId : null
}

export function getCarAuthStoreCode() {
	return window.__carAuthStoreCode != null ? String(window.__carAuthStoreCode).trim() : ''
}

export function getRulePointMeta(ruleCode) {
	const pointIndex = CAR_RULE_POINT_INDEX[ruleCode]
	if (pointIndex == null) return null
	const legacy = CAR_POINT_INDEX_LEGACY[pointIndex]
	const isVerify = legacy === 'hexiao1' || legacy === 'gift'
	return {
		pointIndex,
		legacy,
		operationType: isVerify ? 'VERIFY' : 'CHECKIN'
	}
}

/**
 * 静默登录后：活动详情 + getOrCreate（对齐 activity-multi.loadUserRecord）
 */
export async function syncCarActivitySession(activityCode) {
	const code = activityCode != null ? String(activityCode).trim() : ''
	if (!code) throw new Error('活动编码不存在')

	const detailRes = await signstoreRequest({
		url: '/signstore/activity/detailByCode',
		params: { activityCode: code }
	})
	if (isUnauthorizedResponse(detailRes)) {
		throw new Error((detailRes && detailRes.msg) || '非法访问')
	}
	if (!isApiOk(detailRes) || !detailRes.data) {
		throw new Error((detailRes && detailRes.msg) || '获取活动详情失败')
	}

	const activity = detailRes.data
	window.__carActivityId = activity.id
	window.__carAuthStoreCode =
		(activity.authStoreCode && String(activity.authStoreCode).trim()) ||
		(activity.store && activity.store.storeCode && String(activity.store.storeCode).trim()) ||
		''

	const recordRes = await signstoreRequest({
		url: '/signstore/activityUser/getOrCreate',
		params: { activityCode: code }
	})
	if (isUnauthorizedResponse(recordRes)) {
		throw new Error((recordRes && recordRes.msg) || '非法访问')
	}
	if (!isApiOk(recordRes) || !recordRes.data || recordRes.data.id == null) {
		throw new Error((recordRes && recordRes.msg) || '获取用户参与记录失败')
	}

	window.__carActivityDetail = activity
	window.__carActivityUserId = recordRes.data.id
	if (recordRes.data.uid != null) {
		try {
			const raw = window.localStorage.getItem('signstore_h5_user_info')
			const parsed = raw ? JSON.parse(raw) : {}
			parsed.uid = recordRes.data.uid
			window.localStorage.setItem('signstore_h5_user_info', JSON.stringify(parsed))
		} catch (e) {
			// ignore
		}
	}
	return recordRes.data
}

function mapPointIndexesToSignlog(pointIndexes) {
	const list = []
	;(pointIndexes || []).forEach(function (idx) {
		const legacy = CAR_POINT_INDEX_LEGACY[idx]
		if (legacy) list.push({ point: legacy })
	})
	return list
}

function readLocalAnswerlog(activityCode, uid) {
	try {
		const key = 'car_survey_' + activityCode + '_' + uid
		const raw = window.localStorage.getItem(key)
		if (!raw) return []
		const parsed = JSON.parse(raw)
		return parsed ? [parsed] : []
	} catch (e) {
		return []
	}
}

export async function submitCarSurvey(payload) {
	const activityUserId = getCarActivityUserId()
	if (!activityUserId) {
		throw new Error('用户参与记录未就绪')
	}
	const res = await signstoreRequest({
		method: 'post',
		url: '/signstore/carSurvey/h5/submit',
		data: Object.assign({ activityUserId }, payload)
	})
	if (isUnauthorizedResponse(res)) {
		throw new Error((res && res.msg) || '非法访问')
	}
	if (!isApiOk(res)) {
		throw new Error((res && res.msg) || '问卷提交失败')
	}
	return res.data
}

export async function fetchCarSurveyRecord() {
	const activityUserId = getCarActivityUserId()
	if (!activityUserId) return null
	const res = await signstoreRequest({
		url: '/signstore/carSurvey/h5/mine',
		params: { activityUserId }
	})
	if (isUnauthorizedResponse(res)) {
		throw new Error((res && res.msg) || '非法访问')
	}
	if (!isApiOk(res)) {
		return null
	}
	return res.data || null
}

export function saveLocalAnswerlog(activityCode, uid, payload) {
	try {
		const key = 'car_survey_' + activityCode + '_' + uid
		window.localStorage.setItem(key, JSON.stringify(payload))
	} catch (e) {
		// ignore
	}
}

/**
 * 替代原 otherapi/index/index：打卡回显走 signstore，问卷暂存本地（待对接 signstore 问卷）
 */
export async function fetchCarUserState(activityCode, uid) {
	const activityUserId = getCarActivityUserId()
	if (!activityUserId) {
		throw new Error('用户参与记录未就绪')
	}
	const checkedRes = await signstoreRequest({
		url: '/signstore/activityUser/checkedPoints',
		params: { activityUserId }
	})
	if (isUnauthorizedResponse(checkedRes)) {
		throw new Error((checkedRes && checkedRes.msg) || '非法访问')
	}
	const pointIndexes = isApiOk(checkedRes) && Array.isArray(checkedRes.data) ? checkedRes.data : []
	let answerlog = []
	try {
		const survey = await fetchCarSurveyRecord()
		if (survey) {
			answerlog = [survey]
		} else {
			answerlog = readLocalAnswerlog(activityCode, uid)
		}
	} catch (e) {
		answerlog = readLocalAnswerlog(activityCode, uid)
	}
	return {
		code: 200,
		data: {
			signlog: mapPointIndexesToSignlog(pointIndexes),
			answerlog: answerlog
		}
	}
}

/** 印章比对（唯一打卡入口，对齐 signstore validateSeal） */
export async function validateSealForCar(touchPoints, ruleCode) {
	const meta = getRulePointMeta(ruleCode)
	const activityUserId = getCarActivityUserId()
	if (!meta || !activityUserId) {
		throw new Error('打卡参数未就绪')
	}
	const res = await signstoreRequest({
		method: 'post',
		url: '/signstore/sealrule/compareSimilarity',
		data: {
			ruleCode,
			touchPoints,
			activityUserId,
			pointIndex: meta.pointIndex,
			operationType: meta.operationType,
			isSignSuccess: 1,
			authStoreCode: getCarAuthStoreCode() || undefined
		}
	})
	// compareSimilarity 返回 SealSimilarityResultDto，非 ApiResult 包装
	if (res && typeof res.matched === 'boolean') {
		return res
	}
	if (res && res.data && typeof res.data.matched === 'boolean') {
		return res.data
	}
	throw new Error((res && res.errorMessage) || (res && res.msg) || '验证失败')
}

export function drawSignStoreLottery(data) {
	return signstoreRequest({
		method: 'post',
		url: '/signstore/lottery/h5/draw',
		data
	})
}

export function listSignStoreLotteryDrawRecords(params) {
	return signstoreRequest({
		url: '/signstore/lottery/h5/drawRecords',
		params
	})
}

export function verifySignStoreLotterySeal(data) {
	return signstoreRequest({
		method: 'post',
		url: '/signstore/lottery/h5/verifySeal',
		data
	})
}
